import RestrictedField from "pages/Legacy/Marketing/components/RestrictedField";
import { FieldColumnType } from "components/Table/TableHeader/FilterSortCell/d";

const _RestrictedFields = (restProps: { isUsed?: boolean }) => [

    {
        Header: "RES SM",
        accessor: "11", // For this column, the accessor is not used
        sellerID: 11, // The seller id is used
    },
    {
        Header: "RES AT",
        accessor: "12",
        sellerID: 12
    },
    {
        Header: "RES NR",
        accessor: "13",
        sellerID: 13
    },
    {
        Header: 'RES ACT',
        accessor: '14',
        sellerID: 14
    },
    {
        Header: 'RES BG',
        accessor: '15',
        sellerID: 15
    },
    {
        Header: 'RES AB',
        accessor: '16',
        sellerID: 16
    },
    {
        Header: 'RES LSG',
        accessor: '17',
        sellerID: 17
    },
    {
        Header: 'RES QBX',
        accessor: '26',
        sellerID: 26
    },
    {
        Header: 'RES SSC',
        accessor: '25',
        sellerID: 25
    },
    {
        Header: 'RES YOSR',
        accessor: '27',
        sellerID: 27
    }

].map(x => ({

    Header: x.Header,
    accessor: x.accessor,
    canFilter: true,
    canSort: false,
    fieldType: FieldColumnType.restrictions,
    style: {
        minWidth: 60,
        width: 60,
    },
    Cell: (props: any) => <RestrictedField {...props} sellerID={x.sellerID} {...restProps} />
}))

const RestrictedFields = _RestrictedFields({})
export const RestrictedFieldsUsed = _RestrictedFields({ isUsed: true })

export default RestrictedFields
